import script from "/app/pages/Users/create_registration_token.vue?type=script";
import "/app/pages/Users/create_registration_token.vue?type=style";
import { render } from "/app/pages/Users/create_registration_token.vue?type=template";
script.render = render;
export default script;
